import React, { useEffect, useState } from 'react';
import { MapPin, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const HomePostcodeReminder = ({ token, onGoToProfile }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${API_URL}/api/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const profile = await res.json();
        setShow(!profile.home_postcode);
      } catch (err) {
        setShow(false);
      }
    };
    load();
  }, [token]);

  if (!show) return null;

  return (
    <div
      className="mb-4 flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-3"
      data-testid="home-postcode-reminder"
    >
      <MapPin className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <p className="font-medium text-amber-900">Add your home postcode to see travel money</p>
        <p className="text-amber-700">
          We use it to work out the driving distance to each job.{' '}
          {onGoToProfile && (
            <button
              onClick={onGoToProfile}
              className="underline font-medium"
              data-testid="home-postcode-reminder-link"
            >
              Open your profile
            </button>
          )}
        </p>
      </div>
      <button onClick={() => setShow(false)} className="text-amber-500 hover:text-amber-700" data-testid="home-postcode-reminder-dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default HomePostcodeReminder;
